import React from 'react'
   
export const Options = ({data, data2}) => {
    return (
        <div className="">
            <Data data={data} />
            <Data data={data2} />
        </div>
    )
}

const Data = ({data, title}) =>{
    let router = {}

    return data ? (
        <div className="options_component  mb-4-">
            {title && (
            <div className="heading">
                <h4 className="title">{'Options' }</h4>
                <div> </div>
            </div> 
            )}
            <ul>
                {
                    data.length>0 && data.map((item,i)=>{
                        return (
                            <li key={'options'+i} className={`${item.sharp&&'red'}`}>
                            <a href={item.url}>
                                    <a className={`${router.pathname === item.url && 'active'}`}>
                                        <div className="symbol">{item.symbol}</div>
                                        <div>{item.title}</div>
                                    </a>
                            </a>
                            </li>
                        
                        )
                    })
                }
            </ul>
        </div>

    ) : <></>
}